import { RECENTLY_VIEWED_ENDPOINT } from '@/constants/endpoints';
import { typedHttp } from '@/modules/http';
import { type RequestBody } from '@/modules/http/type-helpers';
import { type GetRecentlyViewedProductsQuery } from '@/modules/recentlyViewed/aliases';

export function fetchRecentlyViewed({
  params,
}: {
  params?: GetRecentlyViewedProductsQuery;
}) {
  return typedHttp.get(RECENTLY_VIEWED_ENDPOINT, {
    params,
    withAuth: true,
    withDeviceId: true,
  });
}

export function updateRecentlyViewed({
  requestBody,
}: {
  requestBody: RequestBody<typeof RECENTLY_VIEWED_ENDPOINT, 'put'>;
}) {
  return typedHttp.put(RECENTLY_VIEWED_ENDPOINT, requestBody, {
    withAuth: true,
  });
}

export function clearRecentlyViewed() {
  return typedHttp.delete(RECENTLY_VIEWED_ENDPOINT, {
    withAuth: true,
  });
}
